"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-rows" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRowData = (0, vue_1.resolveComponent)("CardRowData");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.renderData.rows, (cardData, i) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRowData, {
                rowData: cardData,
                key: i
            }, null, 8, ["rowData"]));
        }), 128))
    ]));
}
